module.exports = __webpack_public_path__ + "img/LOGO_letter_2.957cb5ba.png";